/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Response_BodyInputs */

const en_contact_point_response_body = /** @type {(inputs: Contact_Point_Response_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message reaches our founder directly, not a shared support queue.`)
};

/**
* | output |
* | --- |
* | "Your message reaches our founder directly, not a shared support queue." |
*
* @param {Contact_Point_Response_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_response_body = /** @type {((inputs?: Contact_Point_Response_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Response_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_response_body(inputs)
});